import set from 'lodash/set'
import { useRouter } from 'next/router'
import { useMemo } from 'react'

/** Query object from the Pages Router (SSR-safe for dynamic routes + search string). */
export function useQueryParams(): Record<string, string> {
  const router = useRouter()

  const queryParams = useMemo(() => {
    const q = router.query
    const acc: Record<string, string> = {}
    for (const [key, raw] of Object.entries(q)) {
      if (raw === undefined) continue
      const value = Array.isArray(raw) ? raw[0] : raw
      if (value === undefined) continue
      set(acc, key, decodeURI(String(value)))
    }
    return acc
  }, [router.query])

  return queryParams
}
